<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>每月请提前分配指标</Alert>
          <slot name="new_btn">
            <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">分配指标</Button>
          </slot>
          <Spin size="large" fix v-if="spinShow"></Spin>

          <!--          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border-->
          <!--                 :columns="columns" :data="tableData"-->
          <!--                 @on-selection-change="handleSelectChange"></Table>-->
          <el-table
            :data="tableData" border
            style="margin-top:10px;width: 100%" size="small">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-divider content-position="left">指标明细</el-divider>
                <el-table
                  size="small"
                  :data="props.row.list"
                  style="width: 100%"
                  max-height="300"
                  border
                  :row-style="{height:'33px'}"
                  :cell-style="{padding:'0px'}"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="month"
                    label="月份"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="day"
                    label="日期"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="user"
                    label="业务员"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="kpi"
                    label="指标"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="docount"
                    label="已完成"
                    align="center">
                  </el-table-column>
                  <el-table-column align="center" width="120">
                    <template slot="header" slot-scope="scope">
                      操作
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        type="danger" icon="el-icon-delete" circle @click="delData(scope, props)" ></el-button>
                    </template>

                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              label="月份" align="center"
              prop="month" sortable>
            </el-table-column>
            <el-table-column
              label="人数" align="center"
              prop="record_count" sortable>
              <template slot-scope="scope">
              <el-link type="primary" @click="showinfo(scope.row.month)" target="_blank">{{scope.row.record_count}}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              label="指标总数" align="center"
              prop="total_kpi" sortable>
            </el-table-column>

          </el-table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>

          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :label-width="100">
              <FormItem
                label="月份"
                prop="month"
              >
                <vue-datepicker-local  type="datetime" v-model="formValidate.month" format="YYYY-MM" placement="bottom-end" disabled ></vue-datepicker-local>
              </FormItem>
              <FormItem
                label="日期"
                prop="day"
              >
                <vue-datepicker-local type="datetime" v-model="formValidate.day" format="YYYY-MM-DD" @input="changeDate"
                                      placeholder="请选择日期"></vue-datepicker-local>
<!--                <el-date-picker  type="date" editable @on-change="changeDate" v-model="formValidate.day" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择日期" ></el-date-picker>-->
              </FormItem>
              <FormItem
                label="指标数"
                prop="kpi"
              >
                <Input
                  v-model="formValidate.kpi"
                  placeholder="指标数" type="number"
                ></Input>
              </FormItem>
              <FormItem
                label="业务员"
                prop="user"
              >
                <el-select v-model="formValidate.users" multiple placeholder="请选择">
                  <el-option
                    v-for="item in userlist"
                    :key="item.user_id"
                    :label="item.nickname"
                    :value="item.user_id">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem
                label="总指标数"
                prop="kpi"
                v-if="formValidate.users.length>1"
              >
                <span>{{formValidate.users.length*formValidate.kpi}}</span>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
          <Modal v-model="monthVisble" title="完成情况" :loading=true :footer-hide=true
                 :width="900"
                 :mask-closable=false>
            <iframe
              :src="'https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=%25E5%258A%25B3%25E5%258A%25A1%25E6%25B4%25BE%25E9%2581%25A3%252F%25E6%258C%2587%25E6%25A0%2587.cpt&month='+selmonth"
              id="mobsf" width="100%" height="600" scrolling="no" frameborder="0"></iframe>

          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getAssistsetkpilist, getuserlist_assist, operationAssistInfo, operationAssistkpi, operationAssistuserkpi
} from '@/api/assist/assistperson.js'
import { getsysparameterList } from '@/api/system/sys_parameter'

import VueDatepickerLocal from 'vue-datepicker-local'

let moment = require('moment')
export default {
  components: { VueDatepickerLocal },
  data () {
    return {
      monthVisble: false,
      selmonth: '',
      userlist: [],
      month: '',
      spinShow: false,
      fullscreenLoading: false,
      sexList: [],
      peduList: [],
      difftypeList: [],
      typeList: [],
      accountList: [],
      accounttypeList: [],
      untypeList: [],
      getinsuranceList: [],
      stateList: [],
      formValidate: { users: [] },
      kpi: 0,
      count_ok: '0',
      ok_percent: '0',
      searchVal: '',
      showProgress: false,
      progressPercent: 0,
      loadingProgress: 0,
      file: null,
      showRemoveFile: false,
      uploadLoading: false,
      tableData: [],
      tableDatatmp: [],
      tableTitle: [],
      tableLoading: false,
      showre: false,
      showretxt: '',
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      business: {
        modalVisible: false,
        modalTitle: '新建',
        meth: 'post'
      },
      businessValidate: {},
      atypelist: [],
      stypelist: [],
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15 // 每页条数

    }
  },
  methods: {

    getAssistkpilist (key, value) {
      this.spinShow = true
      getAssistsetkpilist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getuserlist () {
      getuserlist_assist('就业帮扶', '', '').then(res => {
        if (res.data.code === 0) {
          this.userlist = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    closeModal () {
      this.dialog.show = false
    },
    inttostr (int) {
      if (int != null) {
        return int.toString()
      } else {
        return ''
      }
    },

    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getuserlist()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1)
      this.formValidate = {
        users: [],
        month: s2,
        kpi: 0
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.month = moment(this.formValidate.month).utcOffset(480).format('YYYY-MM')
            this.formValidate.day = moment(this.formValidate.day).utcOffset(480).format('YYYY-MM-DD')
            operationAssistuserkpi(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getAssistkpilist(this.searchVal)
                } else {
                  this.getAssistkpilist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    delData (params, tabledata) {
      console.log(params)
      if (confirm(`确定要删除该指标吗？`)) {
        operationAssistkpi(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handleSubmitBuss (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.businessValidate.assist_time = moment(this.businessValidate.assist_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationAssistInfo(this.businessValidate, this.business.meth).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getAssistkpilist(this.searchVal)
                } else {
                  this.getAssistkpilist()
                }
                this.business.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleResetBuss (name) {
      this.$refs[name].resetFields()
    },
    changeDate (e) {
      console.log(e)
      this.formValidate.month = moment(e).utcOffset(480).format('YYYY-MM')
    },
    showinfo (month) {
      this.monthVisble = true
      this.selmonth = month
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    handleRemove () {
      this.showProgress = false
      this.showre = false
      this.initUpload()
      this.$Message.info('上传的文件已删除！')
    },
    handlerimport () {
      if (this.tableDatatmp.length > 0) {
        this.uploadLoading = true
        importexceldata({ 'data_list': this.tableDatatmp, 'filename': this.file.name }, 'post').then(
          res => {
            this.progressPercent = 101
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.showre = true
              this.showretxt = res.data.msg
              this.uploadLoading = false
              this.getAssistkpilist(this.searchVal)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        this.uploadLoading = false
      }
    },
    readFile (file) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadstart = e => {
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
      }
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100)
      }
      reader.onerror = e => {
        this.$Message.error('文件读取出错')
      }
      reader.onload = e => {
        this.$Message.info('文件读取成功')
        this.progressPercent = 100
        const data = e.target.result
        const { header, results } = excel.read(data, 'array')
        const tableTitle = header.map(item => {
          return { title: item, key: item }
        })
        this.tableDatatmp = results
        this.tableTitle = tableTitle
        this.uploadLoading = false
        this.tableLoading = false
        this.showRemoveFile = true
        // this.showProgress = false
      }
    },
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.readFile(file)
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
        this.file = file
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    handleUploadFile () {
      this.initUpload()
    },
    initUpload () {
      this.file = null
      this.showProgress = false
      this.loadingProgress = 0
      this.tableDatatmp = []
      this.tableTitle = []
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getAssistkpilist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
